export const checkTaxType = (idRamo: number, idSector: number) => {
  let type = 'Timbres';

  const timbre = {
    sector: [
      48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78,
      79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
    ],
    ramo: [0],
  };

  const impuesto_1x100 = {
    sector: [99, 100, 101],
    ramo: [0],
  };

  const mineralesNoMetalicosGuia = {
    sector: [0],
    ramo: [0],
  };

  const mineralesNoMetalicosRegalia = {
    sector: [0],
    ramo: [0],
  };

  const materialesEstrategicos = {
    sector: [0],
    ramo: [0],
  };

  if (timbre.sector.includes(idSector)) {
    type = 'Timbres';
  } else if (impuesto_1x100.sector.includes(idSector)) {
    type = '1x100';
  } else if (mineralesNoMetalicosGuia.sector.includes(idSector)) {
    type = 'mineralesGuia';
  } else if (mineralesNoMetalicosRegalia.sector.includes(idSector)) {
    type = 'mineralesRegalia';
  } else if (materialesEstrategicos.sector.includes(idSector)) {
    type = 'MaterialesEstrategicos';
  }

  return type;
};
